export type YAMNetGroupKey = 'speech' | 'conversation' | 'babble' | 'shouting';

/**
 * AudioSet-Indizes für YAMNet (yamnet_class_map.csv).
 * Wichtig: Klassen nicht überlappend zuordnen — sonst gewinnt oft fälschlich „Einzelsprecher“.
 */
export const YAMNET_GROUP_CLASS_INDICES: Record<YAMNetGroupKey, number[]> = {
  /** Klarer Sprechton, kein Gruppengespräch / Gemurmel */
  speech: [0, 1, 3, 5],
  conversation: [2],
  /** Klassenraum-Gemurmel: Flüstern, Geplapper, Menge, Hubbub, Kinder */
  babble: [4, 12, 63, 64, 65, 66, 507, 513],
  /** Rufen, Schreien (keine Tier-/Schlaggeräusche) */
  shouting: [6, 7, 8, 9, 10, 11]
};
